<template>
	<div class="index" @click="shareShow = false">
		<div :class="$i18n.locale === 'zh'?'index-banner index-banner-s':'index-banner'">
      <img width="100%" :src="$i18n.locale === 'hk'?require('../../static/images/banner-m.jpg'):require('../../static/images/banner-m-s.png')" class="hidden-sm-and-up" alt="">
      <div class="wrap">
        <a href="https://www.ctexcel.com.hk/index"><img class="logo" src="../../static/images/logo.png" alt=""></a>
        <div class="lang">
          <a href="javascript: void(0)" @click="changeLang('hk')" :class="$i18n.locale === 'hk'?'active': ''">繁</a>
          <span>｜</span>
          <a href="javascript: void(0)" @click="changeLang('zh')" :class="$i18n.locale === 'zh'?'active': ''">简</a>
        </div>
      </div>
    </div>
    <div class="index-videoCon">
      <div class="wrap">
        <div class="con">
          <!-- <div class="getNewCard clearfix">
            <div class="left">
              <span>HK$</span>
              <span>0</span>
              <span>=</span>
              <span>
                <img src="../../static/images/icon-simCard.png" />
                <i>{{$t('index.getNewCard.phoneCard')}}</i>
              </span>
              <span>+</span>
              <span>
                <i class="data1">1GB</i> <i>{{$t('index.getNewCard.phoneDate1')}}</i>
                <i class="data2">50MB</i> <i>{{$t('index.getNewCard.phoneDate2')}}</i>
              </span>
              <span>+</span>
              <span>
                <i>100min</i><br />
                <i v-html="$t('index.getNewCard.phoneTalk')"></i>
              </span>
            </div>
            <div class="right">
                <a href="#/fillInfo" @click="indexMark('100')" class="red">
                    <img src="../../static/images/free-btnIcon.png" alt="" />
                    <div class="">
                    	<p>{{$t('index.getNewCard.freeCard1')}}</p>
                    	<p>{{$t('index.getNewCard.freeCard2')}}</p>
                    </div>
                    <span></span>
                </a>
            </div>
            <div class="right">
            	<a href="#/pkgList" @click="indexMark('105')" class="blue">
                    <img src="../../static/images/order-btnIcon.png" alt="" />
                    <div class="">
                    	<p>{{$t('index.getNewCard.orderPkg1')}}</p>
                    	<p>{{$t('index.getNewCard.orderPkg2')}}</p>
                    </div>
                    <span></span>
                </a>
            </div>
          </div> -->
          <!--正式https://www.ctexcel.com.hk/toStudentEvent 测试https://dev.ctexcel.com.hk/ctghk/toStudentEvent-->
          <!-- <p class="toCardInfo"><a href="https://www.ctexcel.com.hk/toStudentEvent">{{$t('index.toCardInfo')}}</a></p> -->
          <div class="advantage">
            <p class="title">{{$t('index.advantage.title')}}</p>
            <div class="msgList">
            	<el-row :gutter="30">
            		<!-- <el-col :sm="6" :xs="24">
            			<a href="https://render.alipay.hk/p/f/fd-jkhyopmp/index6xax5h1g7.html" target="_blank" class="hidden-xs-only">
	            			<div class="msgList-box">
	            				<p class="top">{{$t('index.advantage.msgList[0].top')}}</p>
	            				<div class="con">
	            					<p class="blue-circle">{{$t('index.advantage.msgList[0].tip3')}}</p>
	            					<p>{{$t('index.advantage.msgList[0].tip1')}}</p>
	            					<p>{{$t('index.advantage.msgList[0].tip2')}}</p>
	            					<p>{{$i18n.locale=='zh'?'高达':'高達'}}<span>HK$75</span>{{$i18n.locale=='zh'?'奖赏':'獎賞'}}</p>
	            				</div>
	            			</div>
            			</a>
            			<a href="https://render.alipay.hk/p/f/fd-jkhz8i2a/index.html" target="_blank" class="hidden-sm-and-up">
	            			<div class="msgList-box">
	            				<p class="top">{{$t('index.advantage.msgList[0].top')}}</p>
	            				<div class="con">
	            					<p>{{$t('index.advantage.msgList[0].tip1')}}</p>
	            					<p>{{$t('index.advantage.msgList[0].tip2')}}</p>
	            					<p>{{$i18n.locale=='zh'?'高达':'高達'}}<span>HK$75</span>{{$i18n.locale=='zh'?'奖赏':'獎賞'}}</p>
	            				</div>
	            			</div>
            			</a>
            		</el-col> -->
            		<el-col :sm="8" :xs="24">
            			<a href="#/pkgList#tranPkg">
	            			<div class="msgList-box">
	            				<p class="top">{{$t('index.advantage.msgList[2].top')}}</p>
	            				<div class="con">
	            					<p>{{$t('index.advantage.msgList[2].tip1')}}</p>
	            					<p class="blue-circle"><span style="font-weight: 700;">4GB</span> / HK$ 68</p>
	            					<p class="blue-circle"><span style="font-weight: 700;">10GB</span> / HK$ 128</p>
	            					<p class="blue-circle"><span style="font-weight: 700;">20GB</span> / HK$ 238</p>
	            					<ul class="list2">
	            						<li v-for="it in $t('index.advantage.msgList[2].list')" v-html="it" :key="it"></li>
	            					</ul>
	            				</div>
	            			</div>
            			</a>
            		</el-col>
                <el-col :sm="8" :xs="24">
            			<a href="#/pkgList#largeFlow" >
	            			<div class="msgList-box msgList-box-big">
	            				<p class="top">{{$t('index.advantage.msgList[1].top')}}</p>
	            				<div class="con">
	            					<p class="blue-circle">{{$t('index.advantage.msgList[1].tip1')}}</p>
	            					<p>{{$t('index.advantage.msgList[1].tip2')}}</p>
	            					<ul class="list1">
	            						<li v-for="it in $t('index.advantage.msgList[1].list')" :key="it">{{it}}</li>
	            					</ul>
	            				</div>
	            			</div>
            			</a>
            		</el-col>
            		<el-col :sm="8" :xs="24">
            			<a href="javascript: void(0)" @click="showAward">
	            			<div class="msgList-box">
	            				<p class="top">{{$t('index.advantage.msgList[3].top')}}</p>
	            				<div class="con">
	            					<p v-html="$t('index.advantage.msgList[3].tip1')"></p>
	            					<!--<p class="award-btn"><a href="javascript:void(0)" @click="showAward">{{$i18n.locale == 'zh'?'详情>':'詳情>'}}</a></p>-->
	            				</div>
	            			</div>
            			</a>
            		</el-col>
        		</el-row>
            <div class="z-link-out"><a href="https://www.ctexcel.com.hk/toStudentEvent">{{$t('index.advantage.linkText')}}</a><span></span></div>
            </div>
          </div>
          <div class="adv">
            <div>
              <p class="z-newtitle">{{$t('index.advantage.h3')}}</p>
            </div>
            <div class="advatageList clearfix">
              <div class="markPart" id="box" :style='{left:slideLeft+"px"}'></div>
              <ul>
                <li v-for="(item,index) in $t('index.advantage.advantageList')" :class="slideIndex==index?'cur':''" @mouseover="hover(index)" :key="index">
                  <span></span>
                  <p>{{item.listText}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="tipList">
            <p :class="slideIndex==index?'tip cur':'tip'" v-for="(item,index) in $t('index.advantage.tipList')" :key="index">{{item.text}}</p>
          </div>
          <div class="videoCon">
              <video muted width="100%" class="myVideo" controls="controls" poster="../../static/images/video-bg.jpg">
              <source src="../../static/images/CTExcel-CorporatelVideo-2017_Eng&Chi11111.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">{{$t('footer')}}</div>
    <!-- <div class="strategyStep">
      <div class="top"></div>
      <div class="mid">
        <div class="con">
          <p class="title">{{$t('index.strategyStep.title')}}</p>
          <p class="tip2">{{$t('index.strategyStep.tip')}}</p>
          <div class="step">
            <p class="hidden-sm-and-down"><img src="../../static/images/step.png" /></p>
            <ul class="hidden-sm-and-down">
              <li v-for="(item,index) in $t('index.strategyStep.stepList')">
                <p>{{item.name}}</p>
                <p>
                  <a :href="item.url" :class="item.class" @click="index==0?indexMark('100'):(index==1?indexMark('101'):indexMark('105'))">
                    <span>{{item.btntext}}</span><img src="../../static/images/icon-next2.png" />
                  </a>
                </p>
              </li>
            </ul>
            <div class="step-m hidden-sm-and-up">
              <a href="#/fillInfo" @click="indexMark('100')">
                <img style="max-width:100%;" :src="$i18n.locale=='zh'?require('../../static/images/step-m-1.png'):require('../../static/images/step-m-1-hk.png')" alt="">
              </a>
              <a href="https://www.ctexcel.com.hk/toActivate" @click="indexMark('101')">
                <img style="max-width:100%;" :src="$i18n.locale=='zh'?require('../../static/images/step-m-2.png'):require('../../static/images/step-m-2-hk.png')" alt="">
              </a>
              <a href="#/pkgList" @click="indexMark('105')">
                <img style="max-width:100%;" :src="$i18n.locale=='zh'?require('../../static/images/step-m-3.png'):require('../../static/images/step-m-3-hk.png')" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="btm"></div>
    </div>
    <div class="wrap">
      <div class="rules">
        <h3>{{$t('getCardSuccess.rules_title')}}</h3>
        <ul>
          <li v-for="it in $t('getCardSuccess.rules')" v-html="it"></li>
        </ul>
      </div>
    </div> -->

    <!-- 右侧share fixed -->
    <div class="rightFixed">
      <div class="con">
        <a href="https://www.ctexcel.com.hk/toActivate" class="activeBtn" @click.stop="indexMark('101')" v-html="$t('index.right.phone')"></a>
        <a href="https://www.ctexcel.com.hk/toLogisticsPage" class="logistics" @click.stop="indexMark('102')" v-html="$t('index.right.order')"></a>
        <a href="javascript:void(0)" class="indexShare" @click.stop="indexMark('103')">{{$t('index.right.share')}}</a>
        <div class="indexShareList" v-show="shareShow">
          <div class="topList">
            <ul class="clearfix">
              <li @click.stop="weibo()">
                <a href="javascript:void(0)">
                  <span></span>
                  <i>{{$t('index.right.weibo')}}</i>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" @click.stop="shareWeixinShow = !shareWeixinShow">
                  <span></span>
                  <i>{{$t('index.right.weChat')}}</i>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" onclick="javascript:window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent('https://images.ctexcel.com.hk/activity/student/#/')+'&t='+encodeURIComponent('香港学生活动'), 'newWindow','center');void(0);">
                  <span></span>
                  <i>{{$t('index.right.facebook')}}</i>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" v-clipboard:copy="message"  @click.stop="onCopy">
                  <span></span>
                  <i>{{$t('index.right.copy')}}</i>
                </a>
              </li>
            </ul>
          </div>
          <div class="weixinCon" v-show="shareWeixinShow">
            <p style="text-align: center;">{{$t('index.right.shareList.weiChatText')}}</p>
            <img src="../../static/images/ewm.png" alt="">
            <!-- <qrcode-vue value="https://www.ctexcel.com.hk" :size="190" level="H" foreground="#183078"></qrcode-vue> -->
            <span class="icon"></span>
          </div>
        </div>
      </div>
    </div>
    <!--赏你赏他弹窗-->
    <pop class="info_award" :is-pop-show.sync="isShowAward" sureBtn_zh="我知道了" sureBtn_hk="我知道了" :is-show-cancel="false" @on-sure="sureAward">
    	<div slot="xw-pop-modal-body" class="xw-pop-modal-body">
    		<h3>{{$t('awardInfo.title')}}</h3>
    		<div class="words">
	    		<p class="title">{{$t('awardInfo.title_tip1')}}</p>
	    		<p>{{$t('awardInfo.tip1')}}</p>
	    		<p class="title">{{$t('awardInfo.title_tip2')}}</p>
	    		<p>{{$t('awardInfo.tip2')}}</p>
	    		<p>{{$t('awardInfo.time')}}</p>
	    		<p class="title">{{$t('awardInfo.title_tip3')}}</p>
	    		<el-collapse-transition>
	    			<div v-show="awardTip3Show" class="tip3">
	    				<template v-for="(it) in $t('awardInfo.tip3')">
	    					<p v-html="it.label" :key="it.label"></p>
	    					<ul v-if="it.child_list" :key="it.child_list">
	    						<li v-for="its in it.child_list" v-html="its" :key="its"></li>
	    					</ul>
	    				</template>
	    			</div>
	    		</el-collapse-transition>
	    		<p class="shrink" style="text-align: center;"><a href="javascript: void(0)" @click="awardTip3Show = !awardTip3Show">{{awardTip3Show?($i18n.locale=='zh'?'收起∧':'收起∧'):($i18n.locale=='zh'?'展开更多∨':'展開更多∨')}}</a></p>
    		</div>
    	</div>
    </pop>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { accessCount } from '@/api/api'
import pop from "@/components/pop"
export default {
  name: 'index',
  components: { pop },
  data () {
    return {
      imageUrl: '',
      slideLeft:'',
      slideIndex:'',
      // 分享
      shareShow:false,
      shareWeixinShow:false,
      toShareMark:true,
      message:"https://images.ctexcel.com.hk/activity/student/#/",
      isShowAward: false,//赏你赏他弹窗
      awardTip3Show: false,//赏你赏他弹窗中的第三大段显示或隐藏
    }
  },
  computed: {
  	...mapState('param',['gutter']),
  },
  methods: {
    onCopy(){
      this.$alert('网站链接已复制，快去分享给好友吧！', '提示', {
        confirmButtonText: '确定'
      })
    },
    changeLang (val) {//简繁切换
  		//console.log(this.$i18n.locale);
      this.$i18n.locale = val,
      console.log(val);
  	},
    hover(index){
      var box = document.getElementById("box")
      var contentWidth = window.getComputedStyle(box).width; 
      this.slideIndex=index;
      this.slideLeft = parseInt(contentWidth)*index;
      console.log(this.slideLeft)
    },

    // share
    // 分享切换
    indexMark (btnId) {
      let _btnId = btnId;
      if(_btnId=='103'){
        this.shareShow = !this.shareShow;
      }
      if(this.toShareMark){
        accessCount({system_id:'1001',btn_id:_btnId}).then(res=>{console.log(res)}).catch((err) =>{
          console.log(err)
        });
        this.toShareMark=false;
      }
      setTimeout(() => {
        this.toShareMark=true;
      },10000)
    },
    weibo(){//微博分享
      var title ='香港学生活动';
      var url ='https://images.ctexcel.com.hk/activity/student/#/';
      var picurl ='';
      this.shareToXl(title,url,picurl);
    },
    shareToXl(title,url,picurl){//微博分享
      var sharesinastring='http://v.t.sina.com.cn/share/share.php?title='+title+'&url='+url+'&content=utf-8&sourceUrl='+url+'&pic='+picurl;
      window.open(sharesinastring,'newwindow','height=400,width=400,top=100,left=100');
    },
    showAward () {//显示赏你赏他弹窗
    	this.isShowAward = true
    },
    sureAward () {//点击弹窗确认按钮，关闭弹窗
    	this.isShowAward = false
    }
  },
  created () {
    accessCount({ system_id:'1001', btn_id: '100' }).then(res=>{
      console.log(res);
    })
  }
}
</script>

<style scoped lang="less">
.footer{ text-align: center; color:#999; font-size: 12px; line-height: 60px; margin-top: 50px;}
    @media (max-width:767px) {
        
    }
.z-link-out {
  margin-top: 50px;
  text-align: center;
  a {
    font-size: 16px;
    color: #147dce;
    text-decoration: underline;
  }
  span {
    display: inline-block;
    width: 33px;
    height: 33px;
    border-radius: 50%;
    background: url(../../static/images/z-linkout-icon.png) no-repeat center center /100% 100%;
    vertical-align: middle;
    margin-left: 10px;
  }

}
.z-newtitle {
  position: relative;
  font-size: 24px;
  text-align: center;
  padding-bottom: 10px;
  &:after {
    width: 28px;
    height: 4px;
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    background-color: #0d71c9;
  }
}
.msgList{
	.msgList-box{
    &.msgList-box-big{ 
      .top {
        color: #eb6922;
        &:before,&:after{ 
          background: url(../../static/images/z-biglist-icon.png) no-repeat center center /100% 100%;
          
        }
      }
    }
		background-color: #fff;
		border-radius: 12px;
		height: 344px;
		overflow: hidden;
		transition: all .5s;
		.top{
			line-height: 48px;
			height: 48px;
			font-size: 16px;
			color: #0d79cd;
			text-align: center;
			font-weight: 700;
			&:before,&:after{
				content: "";
				display: inline-block;
				width: 12px;
				height: 12px;
				background: url(../../static/images/msgList-topIcon.png) no-repeat;
			}
			&:before{
				margin-right: 10px;
			}
			&:after{
				margin-left: 10px;
			}
		}
		.con{
			text-align: center;
			padding: 33px 22px 0;
			height: calc(100% - 48px);
			box-sizing: border-box;
			font-size: 16px;
			color: #129ded;
			.blue-circle{
				display: inline-block;
				color: #fff;
				font-size: 14px;
				line-height: 24px;
				border-radius: 12px;
				background-color: #129ded;
				padding: 0 15px;
				margin-bottom: 3px;
			}
		}
		&:hover{
			// transform: scale(1.01);
			box-shadow: 0px 5px 30px rgba(7,112,255,.3);
		}
	}
	// .el-col:nth-child(1) .msgList-box .con{background: url(../../static/images/msgList-bg1.jpg) no-repeat top center/100% 100%;}
	// .el-col:nth-child(1) .msgList-box .con p:nth-child(2),&:nth-child(1) p:nth-child(2){line-height: 20px;}
	// .el-col:nth-child(1) .msgList-box .con p:nth-child(2){margin-top: 5px;}
	// .el-col:nth-child(1) .msgList-box .con p:nth-child(4){font-size: 20px;font-weight: 700;margin-top: 5px;}
	// .el-col:nth-child(1) .msgList-box .con p:nth-child(4) span{font-size: 32px;color: #ff861e;}
	.el-col:nth-child(2) .msgList-box .con{background: url(../../static/images/msgList-bg2.jpg) no-repeat top center/100% 100%;}
	.el-col:nth-child(2) .msgList-box .con p:nth-child(2){font-size: 20px;font-weight: 700;}
	.el-col:nth-child(2) .msgList-box .con .list1{text-align: left;display: inline-block;margin-top: 20px;}
	.el-col:nth-child(2) .msgList-box .con .list1 li{line-height: 25px;position: relative;}
	.el-col:nth-child(2) .msgList-box .con .list1 li:before{content: "";position: absolute;display: inline-block;width: 15px;height: 15px;background: url(../../static/images/list-arrow.png) no-repeat;top: 5px;left: -20px;}
	.el-col:nth-child(1) .msgList-box .con{background: url(../../static/images/msgList-bg3.jpg) no-repeat top center/100% 100%;}
	.el-col:nth-child(1) .msgList-box .con p:nth-child(1){font-size: 18px;font-weight: 700;margin-bottom: 5px;}
	.el-col:nth-child(1) .msgList-box .con .blue-circle{width: 137px;box-sizing: border-box;}
	.el-col:nth-child(1) .msgList-box .con .list2 li{font-size: 14px;line-height: 22px;text-align: left;}
	.el-col:nth-child(3) .msgList-box .con{background: url(../../static/images/msgList-bg4.jpg) no-repeat top center/100% 100%;}
	.el-col:nth-child(3) .msgList-box .con p{text-align: left;}
}
.award-btn{
	text-align: right!important;
	a{
		color: #17aafd;
		font-size: 14px;
	}
}
@media (min-width:768px) {
  .msgList{
    .msgList-box-big{
      transform: scale(1.08)
    }
  }
    .rules{
      padding: 20px 50px 50px;
      color: #666;
      h3{
        font-size: 14px;
        color: #333;
        line-height: 14px;
        margin-bottom: 20px;
      }
      li{
        line-height: 20px;
      }
      li:nth-child(5){
        overflow: hidden;
      }
    }
    .logo{position:absolute; top:20px; left:35px;}
    .msgList{margin: 50px 0 100px;}
}
@media (max-width:767px) {
    .footer{ margin-top: 0;}
    .z-link-out { 
      margin-top: 20px;
      a {
        font-size: 14px;
      }
      span {
        width: 24px;
        height: 24px;
      }
    }
    .z-newtitle {
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    &:after {
      width: 28px;
      height: 4px;
      content: '';
      display: block;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      background-color: #0d71c9;
    }
  }
    .wrap{
      padding: 0 20px;
    }
    .rules{
      padding: 20px 0;
    }
    .logo{position:absolute; top:12px; left:20px; width: 120px;}
    .msgList{
    	margin-top: 20px;
    	.msgList-box{
    		overflow: hidden;
    		margin-bottom: 15px;
    		box-shadow: 0 0 15px rgba(23,138,227,.5);
		}
		.el-col:nth-child(1) .msgList-box .con{background: url(../../static/images/msgList-bg1-m.jpg) no-repeat top center/100% 100%;}
		.el-col:nth-child(2) .msgList-box .con{background: url(../../static/images/msgList-bg2-m.jpg) no-repeat top center/100% 100%;}
		.el-col:nth-child(3) .msgList-box .con{background: url(../../static/images/msgList-bg3-m.jpg) no-repeat top center/100% 100%;}
		.el-col:nth-child(4) .msgList-box .con{background: url(../../static/images/msgList-bg4-m.jpg) no-repeat top center/100% 100%;}
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue